import { privateApi } from "../api/axios";

export const getDepartments = async () => {
    try {
        const response = await privateApi.get("api/departments");
        return response;
    } catch (error) {
        throw error;
    }
}

// Production
export const getProductionByDepartment = async (startDate: string, endDate: string) => {
    try {
        const response = await privateApi.get(`api/departments/report?startDate=${startDate}&endDate=${endDate}`);
        return response;
    } catch (error) {
        throw error;
    }
}